import { Component, Input, OnInit } from "@angular/core";
export interface PeriodicElement {
  constructor_name: string;
  title: string;
  links: any[];
}
@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.css"],
})
export class BreadcrumbComponent implements OnInit {
  @Input() constructor_name: any;
  constructor() { }

  itemLinks!: PeriodicElement;
  ngOnInit(): void {
    this.fnGetItemLink(this.constructor_name);
  }

  fnGetItemLink(constructor_name: string) {
    const _listLinks: PeriodicElement[] = [
      {
        constructor_name: "InicioViewComponent",
        title: "Inicio",
        links: [],
      },
      {
        constructor_name: "NosotrosViewComponent",
        title: "Nosotros",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "PublicacionesViewComponent",
        title: "Publicaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "QrListViewComponent",
        title: "QR List",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "CatalogoViewComponent",
        title: "Catálogo de variedades de papa",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "CatalogoInfoViewComponent",
        title: "Acerca de",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "CatalogoItemViewComponent",
        title: "Variedad",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
          {
            indice: "Catálogo",
            valor: "/catalogo",
          },
        ],
      },

      {
        constructor_name: "OwnExplorationsViewComponent",
        title: "Mis Observaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "ExplorerViewComponent",
        title: "Observaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ExplorerItemViewComponent",
        title: "Observación",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
          {
            indice: "Observaciones",
            valor: "/observaciones",
          },
        ],
      },
      {
        constructor_name: "CatalogoSearchViewComponent",
        title: "Filtros Avanzados",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
          {
            indice: "Catálogo",
            valor: "/catalogo",
          },
        ],
      },
      //
      {
        constructor_name: "CatalogoListViewComponent",
        title: "Editar variedades",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "CatalogoItemEditViewComponent",
        title: "Editar variedad",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "CatalogoItemNewViewComponent",
        title: "Agregar nueva variedad",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ExplorerItemEditViewComponent",
        title: "Editar observación",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
          {
            indice: "Tablero",
            valor: "/tablero/explorer-list-edit",
          },
        ],
      },

      {
        constructor_name: "ExplorerItemNewViewComponent",
        title: "Agregar nueva observación",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ExplorerItemFavoritesViewComponent",
        title: "Favoritos",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ConfigurarCuentaViewComponent",
        title: "Configuracion de la cuenta",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "ProfileViewComponent",
        title: "Perfil",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "TableroViewComponent",
        title: "Tablero",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "CatalogoImportViewComponent",
        title: "Importar variedades",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ExplorerImportViewComponent",
        title: "Importar observaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "ExplorerListEditViewComponent",
        title: "Editar observaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ConsumeMiskiPapaViewComponent",
        title: "Consume MISKI papa",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "RegistraVariedadesViewComponent",
        title: "Registra tus variedades",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "AppmovilViewComponent",
        title: "VarScout",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "ContactoViewComponent",
        title: "Contacto",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "PolicyAViewComponent",
        title: "Policy A",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "PolicyBViewComponent",
        title: "Policy B",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "PolicyCViewComponent",
        title: "Policy C",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "ExplorationManagementViewComponent",
        title: "Gestión de observaciones",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },

      {
        constructor_name: "ComunidadesViewComponent",
        title: "Comunidades",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "GuardianesViewComponent",
        title: "Guardianes",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
      {
        constructor_name: "GuardianesItemViewComponent",
        title: "Guardian",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
          {
            indice: "Guardianes",
            valor: "/guardianes",
          },
        ],
      },
      {
        constructor_name: "ErrorViewComponent",
        title: "Error",
        links: [
          {
            indice: "Inicio",
            valor: "/inicio",
          },
        ],
      },
    ];

    this.itemLinks = _listLinks.filter(
      (obj1) => obj1.constructor_name === constructor_name
    )[0];
  }
}
